import React from 'react';
import DemoUSPBadges from './DemoUSPBadges';

const DemoMagicBenefits = ({ scenario }) => {
  if (!scenario) {
    return (
      <div className="demo-magic-benefits">
        <div className="demo-magic-box">
          <div className="demo-box-title">Platform USP Spotlight</div>
          <div className="demo-box-empty">Select a scenario to view platform capabilities.</div>
        </div>
        <div className="demo-benefits-box">
          <div className="demo-box-title">Benefits</div>
          <div className="demo-box-empty">Select a scenario to view details.</div>
        </div>
      </div>
    );
  }

  const spotlightItems = scenario.uspSpotlight || scenario.underlyingMagic || [];
  const benefitItems = scenario.benefits || [];

  return (
    <div className="demo-magic-benefits">
      <div className="demo-magic-box">
        <div className="demo-box-title">Platform USP Spotlight</div>
        {scenario.uspTags && (
          <div style={{ marginBottom: 10 }}>
            <DemoUSPBadges uspTags={scenario.uspTags} />
          </div>
        )}
        <ul className="demo-box-list">
          {spotlightItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="demo-benefits-box">
        <div className="demo-box-title">Benefits</div>
        <ul className="demo-box-list">
          {benefitItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DemoMagicBenefits;
